import { Switch, withStyles } from "@material-ui/core";

export const Toggle = withStyles((theme) => ({
  root: {
    width: 49,
    height: 24,
    padding: 0,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      width: 39,
      height: 18
    }
  },
  switchBase: {
    "padding": 4,
    "color": theme.palette.grey[500],
    "&$checked": {
      "transform": "translateX(26px)",
      "color": theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: "#f7815c"
      },
      [theme.breakpoints.down("xs")]: {
        transform: "translateX(20px)"
      }
    },
    [theme.breakpoints.down("xs")]: {
      padding: 2
    }
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: "0 1px 4px 0 #595959",
    background: "#fff",
    [theme.breakpoints.down("xs")]: {
      width: 14,
      height: 14
    }
  },
  track: {
    borderRadius: "13px",
    opacity: 1,
    backgroundColor: "#e6e6e6"
  },
  checked: {}
}))(Switch);
